import { TZ, clParts } from "@/lib/chileTime";

export const CLP = (n) =>
  "$" + Math.round(n || 0).toLocaleString("es-CL");

export const UF = (n) =>
  (n || 0).toLocaleString("es-CL", { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + " UF";

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-CL", {
      timeZone: TZ, weekday: "short", day: "numeric", month: "long",
    });
  } catch {
    return iso;
  }
};

const DAYS3 = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
const MONTHS3 = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const hhmm = (p) => `${String(p.h).padStart(2, "0")}:${String(p.mi).padStart(2, "0")}`;

// "Lun, 12 de oct. 10:00 - 11:00 hrs" (formato 24 h, siempre hora de Chile)
export const formatSessionRange = (start, durationMin = 0) => {
  const s = clParts(start);
  const e = clParts(new Date(start).getTime() + durationMin * 60000);
  const day = `${DAYS3[s.wd]}, ${s.d} de ${MONTHS3[s.m - 1]}.`;
  const time = durationMin > 0 ? `${hhmm(s)} - ${hhmm(e)} hrs` : `${hhmm(s)} hrs`;
  return `${day} ${time}`;
};


export const formatDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-CL", {
      timeZone: TZ, weekday: "long", day: "numeric", month: "long",
      hour: "2-digit", minute: "2-digit", hour12: false,
    });
  } catch {
    return iso;
  }
};

export const formatDateNumeric = (iso) => {
  if (!iso) return "";
  try {
    const d = clParts(iso);
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.d)}/${p(d.m)}/${d.y}`;
  } catch {
    return iso;
  }
};

export const formatTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("es-CL", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: false });
  } catch {
    return iso;
  }
};
